import React from 'react';
import PicklistTableBase from '../PicklistTableBase';
import { usePicklistDetailsSelector, usePicklistPermissions } from 'hooks/Picklist';
import { looseItemsTableConfig } from '../../../helpers';
import { LooseItemCellContent } from '../Cells';

export function PicklistLooseItems(props) {
  const {
    looseItems,
    filter,
    criteria: { picklistAssetStatuses }
  } = usePicklistDetailsSelector();
  const permissions = usePicklistPermissions();
  const { canEditLooseItem } = permissions;

  return (
    <PicklistTableBase
      {...props}
      tableData={looseItems}
      tableConfig={looseItemsTableConfig}
      filter={filter}
      assetStatuses={picklistAssetStatuses}
      permissions={permissions}
      addDataLabel="Add loose items to the picklist."
      renderNameCell={(row) => (
        <LooseItemCellContent
          row={row}
          onEditLooseItem={props.onEditLooseItem}
          isEditable={canEditLooseItem(row)}
        />
      )}
    />
  );
}
